import '../css/styles.css'

export default function CallTags({ name, id }) {
  return (
    <div className="callTage flexRow" key={id}>
      {name}
    </div>
  )
}
